class FooterController {}

export default FooterController;



// WEBPACK FOOTER //
// ./client/components/footer/footer.controller.js